import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTimePicker } from '../../../../../../../components/dialog-time-picker';
import { millisecondsToTime, timeToMilliseconds } from '../../../../../../../utils/helpers/time-convert';
import { TimeActivationButton } from '../time-activation-button';

type TimeActivationProps = {
  value: number;
  index: number;
  onBtnClick: (value: number) => void;
  onTimeChange?: (value: number, index: number) => void;
  active?: number | null;
};

export const TimeActivation: React.FC<TimeActivationProps> = ({ value, index, onTimeChange, onBtnClick, active }) => {
  const { t } = useTranslation('channel-details');
  const [showActivationTimeDialog, setShowActivationTimeDialog] = useState<boolean>(false);
  const time = millisecondsToTime(value);

  const onHold = () => setShowActivationTimeDialog(true);

  const handleSave = (time: string) => {
    const milliseconds = timeToMilliseconds(time);
    onTimeChange?.(milliseconds, index);
  };

  return (
    <>
      <TimeActivationButton
        value={value}
        {...(onTimeChange && { onHold })}
        onClick={() => onBtnClick(value)}
        active={active === value}
      />
      {onTimeChange && (
        <DialogTimePicker
          header={`${t('timeActivationDialog')} [HH:mm:ss]`}
          open={showActivationTimeDialog}
          setOpen={setShowActivationTimeDialog}
          onSave={(value) => handleSave(value)}
          time={time}
          showSeconds
        />
      )}
    </>
  );
};
